export const AUTOMATIONS_PATH = '/automations';
